export default function Logo({ variant = "gradient", className = "h-8", showWord = true }) {
    const gradient = "https://customer-assets.emergentagent.com/job_15903e42-892a-4550-8865-b8948fdc7338/artifacts/1r56dm5d_DeCloudX%20Logo%20%20%281%29.png";
    const white = "https://customer-assets.emergentagent.com/job_15903e42-892a-4550-8865-b8948fdc7338/artifacts/5rz8sh0h_DeCloudX%20Logo%20%20%283%29.png";
    const icon = "https://customer-assets.emergentagent.com/job_15903e42-892a-4550-8865-b8948fdc7338/artifacts/dme975c0_DeCloudX%20Logo%20.png";

    const src = !showWord ? icon : variant === "white" ? white : gradient;
    return (
        <img
            src={src}
            alt="DeCloudX"
            className={className + " object-contain select-none-strict"}
            data-testid="brand-logo"
            draggable={false}
        />
    );
}
